import { render } from "./MatchRecapPage.vue?vue&type=template&id=5852a8d4&scoped=true"
import script from "./MatchRecapPage.vue?vue&type=script&lang=js"
export * from "./MatchRecapPage.vue?vue&type=script&lang=js"

import "./MatchRecapPage.vue?vue&type=style&index=0&id=5852a8d4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5852a8d4"]])

export default __exports__